import React from 'react'

const CartContext = React.createContext({
  cartList: [],
  addCartItem: () => {},
  deleteCartItem: () => {},
  incrementQuantity: () => {},
  decerementQuantity: () => {},
  emptyCartList: () => {},
})

export default CartContext
